import React, { useState, useEffect, Fragment } from "react";
import { Link } from 'react-router-dom';
import CardNews from "./card_news";
import Loader from '../common/loaderapp';

const News = () => {
    const [news, setNews] = useState([])
    const [actualizar, setActualizar] = useState(false)
    const [load, setLoad] = useState(true)

    useEffect(() => {
        fetch('/rt_obtener_news', {headers: {'Content-Type': 'application/json'}})
        .then(res => res.json())
        .then(res => {
            console.log(res);
            setNews(res.result)
            setActualizar(false)
            setLoad(false)
        })
        .catch(err => console.log('Error:',err))
    }, [actualizar]);

    return (
        <Fragment>
            {load ? 
            <Loader/>: 
            <Fragment>
                <div className="col-sm-12 mt-5 mb-5">
                    <div className="row">
                        <div className="col-sm-12 mb-2 mt-3"></div>
                    </div>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <h5>News</h5>
                            <p>You can edit the name, photo and title, also you can add news or delete them.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mb-4">
                            <Link to="/news-edit/0">
                                <button className="btnAddSpeaker btnOrange">Add News</button>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        { news.map(x=><CardNews key={x.ID_NE} data={x} setActualizar={setActualizar}/>) }
                    </div>
                </div>
            </Fragment >
            }
        </Fragment>
    );
}
export default News;